import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
//
export const selection = data => {
  const {
    pageIndex,
    pageSize,
    ...rest
  } = data;
  const _data = { ...rest
  }; // if (data.assets) {
  //   _data.assets = [60, data.assets];
  // }

  return axios.post(Urls.selectUrl, {
    page: pageIndex,
    page_size: pageSize,
    filters: { ..._data
    },
    orders: {
      created_at: {
        desc: true,
        enable: true
      }
    }
  });
};
//
export const useSelect = ({
  params,
  config
}) => {
  return useQuery([ListQueryKey, params], () => selection(params), config);
};